import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import ContactHead from '../Contact/ContactHead';
import CuisineStart from './CuisineStart';
import CuisineTreat from './CuisineTreat';
import CuisineFresh from './CuisineFresh';

const imageHead = {
  title: 'The Spirit of the Forest: Dining at <br/>Ice and Spice',
  image: "../image/jimcorbett-cuisine-banner.webp",
  breadcrumb: [
    {
      slug: "/resort-de-coracao-corbett",
      name: "Jim Corbett",
    },
    {
      name: "Dining",
    },
  ]
}

const quoteHead = {
  desc: "There is a unique sense of comfort in dining close to the wild. At De Coração Jim Corbett’s Ice and Spice, we focus on fresh, locally-sourced ingredients and deep, authentic flavors that warm the soul. Whether you are dining in our warm indoor hall or under the canopy of trees, the combination of the forest's natural soundtrack and our personalized service ensures that every meal is more than just food—it’s a memory of the wilderness.",
  title: "An Overview",
};

const startData = {
  title: "A Fresh Beginning: The Forest-View Breakfast",
  timing: "Daily from 7:30 am to 11:00 am ",
  desc: "<p>The crisp jungle air and the first light of the sun mark the beginning of a calm morning. Enjoy a forest-view breakfast featuring mountain coffee, freshly baked artisanal breads, Kumaoni specialties, and classic egg preparations on our open deck, surrounded by panoramic forest views and the quiet excitement of Jim Corbett.</p>",
  topLeftImg: "/image/jimcorbett-cuisine-start-1.webp",
  topRightImg: '/image/jimcorbett-cuisine-start-2.webp',
  bottomImg: "/image/jimcorbett-cuisine-start-3.webp",
}

const treatData = {
  leftImg: "/image/jimcorbett-cuisine-treat-1.webp",
  rightImg: "/image/jimcorbett-cuisine-treat-2.webp",
  title: "Mid-Day Cravings and Afternoon Treats",
  desc: `<p><label>From 12:00 pm to 2:00 pm,</label> you can choose from a range of hearty specialties on our gourmet menu—perfect for refueling after a long morning trek. If you’re returning from a dusty safari in the afternoon and need a little pick-me-up, a selection of freshly made cakes and local sweets awaits you <label> from 2:30 pm onwards.</label> Our bar is also open throughout the day, serving chilled refreshments to keep you cool under the sun.</p>
  `
}

const diningData = {
  title: "Evening Wilderness Dining at De Coração",
  timing: "Daily from 7:00 pm onwards",
  desc: `<p>As the forest settles into the night, join us for a relaxed dining experience at our open-air restaurant and live outdoor kitchen. Savor a thoughtfully prepared dinner featuring a blend of global classics and grilled specialties. It’s the perfect time to share stories of your sightings over a drink from our curated collection. End your night by the warmth of our crackling fireplace lounge, the ultimate way to wrap up a day in the wild.</p>`,
  topLeftImg: "/image/jimcorbett-cuisine-dining-1.webp",
  topRightImg: '/image/jimcorbett-cuisine-dining-2.webp',
  bottomImg: "/image/jimcorbett-cuisine-dining-3.webp",
}

const freshData = [
  {
    img: "/image/cuisine-fresh-1.webp",
    title: "Fresh Sourcing",
    desc: "Locally sourced produce for authentic flavors."
  },
  {
    img: "/image/cuisine-fresh-2.webp",
    title: "Gourmet Dining",
    desc: "Carefully crafted multi-course culinary experiences."
  },
  {
    img: "/image/cuisine-fresh-3.webp",
    title: "Diverse Cuisine",
    desc: "Variety of regional and international flavors."
  },
  {
    img: "/image/cuisine-fresh-4.webp",
    title: "Cozy Ambience",
    desc: "Warm and relaxing dining atmosphere."
  }
];


const signData = {
  leftImg: "/image/jimcorbett-cuisine-sign-1.webp",
  rightImg: "/image/jimcorbett-cuisine-sign-2.webp",
  title: "Signature Dinner Experience",
  desc: `<p>Make your special moments truly memorable with a Thoughtfully Curated Dinner at De Coração. Savor exquisite flavors prepared with care, from beautifully crafted dishes to a diverse selection of culinary delights designed to please every palate.</p>
  <p>Settle into a warm and refined atmosphere that complements every meal, offering the ideal space to unwind, share conversations, and create cherished moments with family and friends.</p>`
}

export default function Cuisine() {
  return (
    <>
      <ImageHeader imageHead={imageHead} />
      <ContactHead quoteHead={quoteHead} />
      <CuisineStart data={startData} headingTag="h1"/>
      <CuisineTreat data={treatData} headingTag="h2"/>
      <CuisineStart data={diningData} headingTag="h3"/>
      <CuisineFresh freshData={freshData} />
      <CuisineTreat data={signData} headingTag="h4"/>
    </>
  )
}
